import { createSelector } from '@reduxjs/toolkit';

const config = [
  { propName: 'createJob', reducerName: 'createJob' },
  { propName: 'updateJob', reducerName: 'updateJob' },
  { propName: 'searchTerm', reducerName: 'searchTerm' },
  { propName: 'filters', reducerName: 'filters' },
  { propName: 'page', reducerName: 'page' },
  { propName: 'sort', reducerName: 'sort' },
  { propName: 'currentView', reducerName: 'currentView' },
  { propName: 'getAllJobs', reducerName: 'getAllJobs' },
];

// Memoised: built inline it returned a fresh object on every call, so every
// consumer re-rendered on any dispatch anywhere in the app.
export const getAtsJobs = createSelector(
  config.map(
    ({ reducerName }) =>
      (state) =>
        state?.atsJobs?.[reducerName]
  ),
  (...values) =>
    config.reduce((acc, { propName }, index) => {
      acc[propName] = values[index];
      return acc;
    }, {})
);
